import { graphql } from 'gql.tada';
import { useMutation } from '@apollo/client';

const UpdateFamilyMutation = graphql.persisted(
  "UpdateFamily",
  graphql(`
    mutation UpdateFamily(
      $familyId: ID!
      $name: String
      $emergencyContacts: [EmergencyContactInput!]
      $authorizedPickup: [AuthorizedPickupInput!]
      $churchAffiliation: ChurchAffiliationInput
      $address: AddressInput
    ) {
      updateFamily(input: {
        familyId: $familyId
        name: $name
        emergencyContacts: $emergencyContacts
        authorizedPickup: $authorizedPickup
        churchAffiliation: $churchAffiliation
        address: $address
     }) {
        family {
          id
          name
          emergencyContacts { name phone relationship }
          authorizedPickup { name phone relationship }
          churchAffiliation { churchName pastorName churchEmail }
          address { street street2 city state zip country }
        }
        userErrors { message path }
      }
    }
  `)
);

export { UpdateFamilyMutation };

export function useUpdateFamily() {
  return useMutation(UpdateFamilyMutation);
}
